export default __webpack_public_path__ + "static/media/person-circle.7ba8eeb6.svg";